<template>
  <div :id="`${source}_meetings_tab_analytics`" class="flex flex-col gap-2">
    <AnalyticsFilterComponent :allowed-filters="meetingsAllowedFilters" />

    <MeetingsGrid :source="`${source}_meetings_tab_analytics`" />

    <MeetingTrendsGraph :source="`${source}_meetings_tab_analytics`" />

    <div class="grid grid-cols-2 gap-2 h-full">
      <TopMeetingAgentsTable
        :source="`${source}_meetings_tab_analytics`"
        class="col-span-1"
      />

      <TopDaysOfTheWeekGraph
        :source="`${source}_meetings_tab_analytics`"
        class="col-span-1"
      />
    </div>

    <div class="grid grid-cols-2 gap-2">
      <BookedMembersGraph
        :source="`${source}_meetings_tab_analytics`"
        :order-type="bookingOrderTypes.DESC"
        class="col-span-1"
      />

      <BookedMembersGraph
        :source="`${source}_meetings_tab_analytics`"
        :order-type="bookingOrderTypes.ASC"
        class="col-span-1"
      />
    </div>

    <MeetingsTable :source="`${source}_meetings_tab_analytics`" />
  </div>
</template>

<script setup>
import {
  bookingOrderTypes,
  meetingsAllowedFilters,
} from "@/src/constants/analyticConstants.js";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import MeetingsGrid from "@/src/views/analytics/v2/meeting_agent_analytics/meetings/MeetingsGrid.vue";
import MeetingsTable from "@/src/views/analytics/v2/meeting_agent_analytics/meetings/MeetingAnalyticsTable.vue";
import BookedMembersGraph from "@/src/views/analytics/v2/meeting_agent_analytics/meetings/BookedMembersGraph.vue";
import MeetingTrendsGraph from "@/src/views/analytics/v2/meeting_agent_analytics/meetings/MeetingTrendsGraph.vue";
import TopMeetingAgentsTable from "@/src/views/analytics/v2/meeting_agent_analytics/meetings/TopMeetingAgentsTable.vue";
import TopDaysOfTheWeekGraph from "@/src/views/analytics/v2/meeting_agent_analytics/meetings/TopDaysOfTheWeekGraph.vue";

const props = defineProps({
  source: { type: String, required: true },
});
</script>
